var module = angular.module('main.customerorder');

module.component('caCustomerOrder',{
    templateUrl: 'main/customerorder/customerordersearch/customerordercontent/customerordercontent.cmp.tpl.html',
    bindings: {
        orderId: '<',
        navigated: '&'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($rootScope, $translate, CustomerOrderApiService, confirmationDialogService, loadSpinnerService, ToasterService, $window) {
    var vm = this;

    //Properties
    vm.customerOrder = {};
    vm.tabSelection = {
        orderRows: true,
        orderDeliveries: false
    };
    vm.showOrderHead = true;

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.changeToOrderRowsTab = changeToOrderRowsTab;
    vm.changeToOrderPaymentsTab = changeToOrderPaymentsTab;
    vm.changeToOrderDeliveriesTab = changeToOrderDeliveriesTab;
    vm.changeToOrderRefundsTab = changeToOrderRefundsTab;
    vm.toggleOrderHead = toggleOrderHead;
    vm.cancelOrder = cancelOrder;
    vm.canAccess = $rootScope.canAccess;
    vm.getStatusTranslation = getStatusTranslation;
    vm.getEllipsis = getEllipsis;
    vm.getOrderTypeTranslation = getOrderTypeTranslation;
    vm.canCancelOrder = canCancelOrder;
    vm.isCompanyOrder = isCompanyOrder;
    vm.printDeliveryNote = printDeliveryNote;
    vm.showDeliveryMethod = showDeliveryMethod;

    function onInit() {
    }
    function onChanges(change) {
        if (change.orderId && change.orderId.currentValue) {
            CustomerOrderApiService.getById(change.orderId.currentValue)
                .then(function(response) {
                    vm.customerOrder = response;
                    setUpGridData();
                    loadGridData();
                });
        }
    }

    function showDeliveryMethod(){
       return vm.customerOrder.deliveryMethod !== undefined
    }

    function setUpGridData() {
    }

    function loadGridData() {
    }

    function changeToOrderRowsTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.orderRows = true;
    }

    function changeToOrderPaymentsTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.orderPayments = true;
    }

    function changeToOrderDeliveriesTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.orderDeliveries = true;
    }

    function isCompanyOrder() {
        return vm.customerOrder.customerKind === "Company";
    }

    function changeToOrderRefundsTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.orderRefunds = true;
    }

    function setAllTabSelectionsToFalse() {
        var keys = Object.keys(vm.tabSelection);
        _.forEach(keys, function(key) {
            vm.tabSelection[key] = false;
        });
    }

    function toggleOrderHead() {
        vm.showOrderHead = !vm.showOrderHead;
    }

    function canCancelOrder() {
        var hasOrder = vm.customerOrder !== undefined;
        var hasOrderStatusCancelled = vm.customerOrder.status === 'cancelled';

        return hasOrder && !hasOrderStatusCancelled;
    }

    function printDeliveryNote() {
        loadSpinnerService.start('mainSpinner');
        CustomerOrderApiService.getDeliveryNotePdf(vm.orderId).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'order.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }
            ToasterService.showSuccess();
        }, function(error) {
            console.log(error);
            ToasterService.showError();
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function getFileName(contentDisposition, defaultValue) {
        //"attachment; filename=PickingList36012-36013.pdf"
        var filename = defaultValue;
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            var filenameRegex = /(?![=]{1})([\w\d\s-_]){1,}.(pdf|csv|xls|xlsx)/ig;
            var matches = new RegExp(filenameRegex).exec(contentDisposition);
            if (matches != null && matches[0]) {
                filename = matches[0];
            }
        }
        return filename;
    }

    function cancelOrder() {
        confirmationDialogService
            .showDialog($translate.instant('customerorder.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    CustomerOrderApiService.cancelById(vm.customerOrder.id).then(function(response) {
                        vm.customerOrder.status = 'cancelled';
                        _.forEach(vm.customerOrder.deliveries, function (o) {
                            o.status = 'cancelled';
                        });
                        vm.isEditing = false;
                        ToasterService.showSuccess($translate.instant('customerorder.orderCancelled'), $translate.instant('customerorder.customerorders'));
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function getStatusTranslation(text) {
        if (text) {
            var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
            return $translate.instant('customerorder.status' + textCapital);
        }
    }

    function getOrderTypeTranslation(text) {
        if (text) {
            var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
            return $translate.instant('customerorder.type' + textCapital);
        }
    }

    function getEllipsis(text, len) {
        if (text && text.length > len) {
            return text.substr(0, len) + '...';
        } else {
            return text;
        }
    }
}
